module.exports = __webpack_public_path__ + "static/media/ETSGlobal_logo.4a029443.svg";